import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
} from '@material-ui/core';
import { sortBy } from 'lodash'

import { getAllSpendingBySupplier } from '../../api/resources/Suppliers';
import { getAllSpendingByCostCentre } from '../../api/resources/CostCentres';

import * as defs from '../resourceList.module.scss';

const LOOKUPS = {
  Supplier: {
    name: 'Supplier',
    slug: 'suppliers',
    function: getAllSpendingBySupplier,
    nameKey: 'supplierName'
  },
  CostCentre: {
    name: 'Cost Centre',
    slug: 'cost-centres',
    function: getAllSpendingByCostCentre,
    nameKey: 'costCentreName'
  }
}

class SpendingOverviewTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      spending: []
    }
  }

  componentDidMount() {
    this.getSpending();
  }

  componentDidUpdate() {
    const { status, location, startDate, endDate, type } = this.props;
    const { status: _status, location: _location, startDate: _startDate, endDate: _endDate, type: _type } = this.state;
    if (type !== _type || status != _status || location != _location || startDate != _startDate || endDate != _endDate) {
      this.setState({
        type, status, location, startDate, endDate,
        loading: true
      }, this.getSpending)
    }
  }

  getSpending() {
    let { status, location, startDate, endDate, type } = this.props;
    if (status === 'any') status = null;
    LOOKUPS[type].function({status, location, startDate, endDate}).then(spending => {
      spending = sortBy(spending, 'totalSpend').reverse();
      this.setState({ spending, loading: false })
    })
  }

  render() {

    const { spending, loading } = this.state;
    const { type } = this.props;

    return (<>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell><strong>{LOOKUPS[type].name}</strong></TableCell>
              <TableCell align="right"><strong>Total spend</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { loading && (
              <tr><td colSpan='4' style={{height: '200px', textAlign: 'center'}}><CircularProgress /></td></tr>
            )}
            { !loading && spending.length === 0 && <tr colspan='2'><td className={defs.resourceListFailedMessage}>No matching spending found</td></tr> }
            { !loading && spending.length > 0 && spending.map((spend, idx) => (
              <TableRow key={idx}>
                <TableCell>
                  {/* <Link to={`/reports/${LOOKUPS[type].slug}/${spend.id}`}>{spend[LOOKUPS[type].nameKey]}</Link> */}
                  {spend[LOOKUPS[type].nameKey]}
                </TableCell>
                <TableCell align="right">£{spend.totalSpend.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>);
  }
}

export default SpendingOverviewTable